import { io } from "socket.io-client";
import { savedPass } from "./pass.js";
import { ClockSync, syncClock, } from "@unfaithful/shared";
export function connectGame(url) {
    return io(url, {
        transports: ["websocket", "polling"],
        // If a WebSocket can't get through (a fussy router, a phone waking up), fall back to polling.
        tryAllTransports: true,
        reconnection: true,
        reconnectionDelay: 500,
        reconnectionDelayMax: 3000,
        // The sandbox pass travels with the connection, so a lost cookie can't lock a player out.
        auth: (cb) => cb({ pass: savedPass() ?? undefined }),
    });
}
export class RequestError extends Error {
    code;
    constructor(code, message) {
        super(message);
        this.code = code;
    }
}
const REQUEST_TIMEOUT_MS = 8000;
/** Promise wrapper over an acknowledged emit. Rejects with RequestError on failure or timeout. */
export function request(socket, event, ...args) {
    return new Promise((resolve, reject) => {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        socket.timeout(REQUEST_TIMEOUT_MS).emit(event, ...args, (err, result) => {
            if (err)
                return reject(new RequestError("timeout", "The castle didn't answer. Check your connection."));
            if (result.ok)
                resolve(result.data);
            else
                reject(new RequestError(result.error.code, result.error.message));
        });
    });
}
/**
 * Keeps a ClockSync fresh: a burst on every (re)connect, then a sample every 20 s.
 * Clocks drift and Wi-Fi changes, so sync is never "done".
 */
export function keepClockSynced(socket, clock = new ClockSync()) {
    const ping = (sentAt) => new Promise((resolve, reject) => {
        socket.timeout(3000).emit("clock:ping", sentAt, (err, serverTime) => err ? reject(err) : resolve(serverTime));
    });
    const burst = () => void syncClock(clock, ping, { samples: 8, gapMs: 50 }).catch(() => undefined);
    socket.on("connect", burst);
    if (socket.connected)
        burst();
    const interval = setInterval(() => {
        if (!socket.connected)
            return;
        const sent = Date.now();
        ping(sent)
            .then((serverTime) => clock.addSample(sent, serverTime, Date.now()))
            .catch(() => undefined);
    }, 20_000);
    return {
        clock,
        stop() {
            clearInterval(interval);
            socket.off("connect", burst);
        },
    };
}
//# sourceMappingURL=connection.js.map